import React from 'react';
import Pages from "../../pages";
import css from "./main.module.scss"

const Main = () => {
  return (
    <div>
      <Pages/>
    </div>
  );
};

export default Main;